import { getSystemCodeReg } from "../betslip/UserConf";
import { getConfiguration } from "./configuration";

export function setCustomizedOdds(bets) {
    const systemCodeToCustomizedOdds = getSystemCodeReg(); // se non e' impostato, varra' come systemcode di skin
    for (let kb in bets) {
    	const bet = bets[kb];
    	let customOddsMap = {};
    	if (bet.qps != null && bet.qps.vl != null) {
    		customOddsMap = bet.qps.vl;
    	}
    	for (let kq in bet.eqs) {
    		const draw = bet.eqs[kq];
    		const keyMapSkinCode = `${systemCodeToCustomizedOdds}:${bet.cs}:${bet.h}:${draw.ce}`;
    		
    		let keyMapGroupCode = null;
    		let keyMapShopCode = null;
    		const operator = window.getLoggedParamsFromLS();
    		if (operator && (window.appConfig.TERMINAL_AGENCY || window.appConfig.SHOP_BOOKER)) {
				if (operator.groupId) {
					const groupKey = `GRP-${operator.groupId}`;
					keyMapGroupCode = `${groupKey}:${bet.cs}:${bet.h}:${draw.ce}`
				}
				const servicesMap = operator.servicesMap ? operator.servicesMap: operator.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					const cnPvendKey = `${cn}_${pvend}`;
					keyMapShopCode = `${cnPvendKey}:${bet.cs}:${bet.h}:${draw.ce}`;
				}

    		} else if (window.appConfig.SELF_CASHIER) {
    			const cashier = window.getVoucherParamsFromLS();
      			if (cashier) {
    				if (cashier.groupId) {
    					const groupKey = `GRP-${cashier.groupId}`;
    					keyMapGroupCode = `${groupKey}:${bet.cs}:${bet.h}:${draw.ce}`
    				}
    				const servicesMap = cashier.servicesMap ? cashier.servicesMap: cashier.hash_servizi;
    				const cnPvend = servicesMap['SPORT'];
    				if (cnPvend) {
    					const cn = cnPvend.split("/")[0];
    					const pvend = cnPvend.split("/")[1];
    					const cnPvendKey = `${cn}_${pvend}`;
    					keyMapShopCode = `${cnPvendKey}:${bet.cs}:${bet.h}:${draw.ce}`;
    				}
    			}
    		}
    		
    		let customizedOdd = null;
    		//high priority: shop
    		if (keyMapShopCode && customOddsMap[keyMapShopCode] !== null) {
    			customizedOdd = customOddsMap[keyMapShopCode];
    		}
    		
    		// less priority: group of this shop
    		if (keyMapGroupCode && customOddsMap[keyMapGroupCode] !== null && !customizedOdd) {
    			customizedOdd = customOddsMap[keyMapGroupCode];
    		}
    		
    		// less priority: skin customization
    		if (customOddsMap[keyMapSkinCode] !== null && !customizedOdd) {
    			customizedOdd = customOddsMap[keyMapSkinCode];
    		}

			// lowest priority: get the customization from another group or shop or skin code
    		const conf = getConfiguration();
			if(!customizedOdd && conf.cosd && conf.cosd.length > 0) {
				const splittedData = conf.cosd.split(";");
				if(splittedData[0] === 'GRP') {
					const substituteGroupId = splittedData[1];
					const keyGroup  = `${substituteGroupId}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keyGroup];
				}
				else if(splittedData[0] === 'CNPVEND') {
					const substituteCnPvend = splittedData[1];
					const keyShop  = `${substituteCnPvend}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keyShop];
				}
				else if(splittedData[0] === 'SKIN') {
					const substituteSystemCode = splittedData[1];
					const keySkin  = `${substituteSystemCode}:${bet.cs}:${bet.h}:${draw.ce}`;
					customizedOdd = customOddsMap[keySkin];
				}
			}
    		if (customizedOdd != null) {
    			draw.q = customizedOdd;
    		}
    	}
    }
}
